import {FormatMessageFunction, ObjectOfAny} from '@fo/shared-types';
import {FieldErrorMessage} from '@fo/designSystem/Fields/types';
import {isValidEmail} from '@fo/root/formValidation';

const getEmailMessage = (
  formatMessage: FormatMessageFunction,
  value: string,
  message?: FieldErrorMessage,
  messageValues: ObjectOfAny = {}
): string | undefined => {
  if (!isValidEmail(value)) {
    const defaultMessage = formatMessage({id: 'phoenix.errors.email.validFormat'});
    return typeof message === 'function' ? message(messageValues) : message || defaultMessage;
  }
  return undefined;
};

export default getEmailMessage;
